<div class="container">

  <app-header-dialog [iconName]="'email'">
    {{ local_title }}
  </app-header-dialog>

  <mat-tab-group>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>analytics</mat-icon>
        <div>Extrato Atual</div>
      </ng-template>

      <div>
        <!-- TABLE -->
        <mat-table [dataSource]="dataSource" style="margin: 10px; height: 490px; overflow:auto;">

          <!-- name Column -->
          <ng-container matColumnDef="product_name">
            <mat-header-cell *matHeaderCellDef> Anuidade </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.product_name }} </mat-cell>
          </ng-container>

          <!-- Value Column -->
          <ng-container matColumnDef="value">
            <mat-header-cell *matHeaderCellDef> Valor </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span *ngIf="element.value !== 0" style="color: darkgreen">
                {{ element.value | currency:'BRL':'':'1.2-2' }}
              </span>
              <span *ngIf="element.value === 0 && element.isFree" style="color: darkgreen">
                {{ element.value }}
              </span>
              <span *ngIf="element.value === 0 && !element.isFree" style="color: red">
                {{ element.value }}
              </span>
            </mat-cell>
          </ng-container>

          <!-- Value Column -->
          <ng-container matColumnDef="free">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span *ngIf="element.isFree">
                Free
              </span>
              <!--
          <span *ngIf="!element.isFree">
            N
          </span>
          -->
            </mat-cell>
          </ng-container>

          <!-- Header -->
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

          <!-- Row -->
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

        </mat-table>
        <!-- END TABLE -->
      </div>

    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>attach_email</mat-icon>
        <div>Extrato Email</div>
      </ng-template>

      <div>
        <!-- TABLE -->
        <mat-table [dataSource]="dataSourceSent" style="margin: 10px; height: 490px; overflow:auto;">

          <!-- name Column -->
          <ng-container matColumnDef="product_name">
            <mat-header-cell *matHeaderCellDef> Anuidade </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.product_name }} </mat-cell>
          </ng-container>

          <!-- Value Column -->
          <ng-container matColumnDef="value">
            <mat-header-cell *matHeaderCellDef> Valor </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span *ngIf="element.value !== 0" style="color: darkgreen">
                {{ element.value | currency:'BRL':'':'1.2-2' }}
              </span>
              <span *ngIf="element.value === 0 && element.isFree" style="color: darkgreen">
                {{ element.value }}
              </span>
              <span *ngIf="element.value === 0 && !element.isFree" style="color: red">
                {{ element.value }}
              </span>
            </mat-cell>
          </ng-container>

          <!-- Value Column -->
          <ng-container matColumnDef="free">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span *ngIf="element.isFree">
                Free
              </span>
              <!--
          <span *ngIf="!element.isFree">
            N
          </span>
          -->
            </mat-cell>
          </ng-container>

          <!-- Header -->
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

          <!-- Row -->
          <mat-row *matRowDef="let row; columns: displayedSentColumns;"></mat-row>

        </mat-table>
        <!-- END TABLE -->
      </div>

    </mat-tab>

  </mat-tab-group>

</div>